import React from "react";
import styled from "styled-components";

const RADIUS = 10;

const StyledMessageStatusIcon = styled.div`
  width: ${RADIUS}px;
  height: ${RADIUS}px;
  display: inline-block;
  border-radius: 100%;

  &.success {
    background-color: ${props => props.theme.colors.green};
  }

  &.error {
    background-color: ${props => props.theme.colors.danger};
  }

  &.warn {
    background-color: ${props => props.theme.colors.orange};
  }

  &.pending {
    background-color: ${props => props.theme.colors.gray2};
  }
`;

interface Props {
  status?: number;
  className?: string;
}

const MessageStatusIcon: React.FC<Props> = ({ status, className = "" }) => {
  let statusClassName;

  if (!status) {
    statusClassName = "pending";
  } else if (status >= 500 || status === 408) {
    statusClassName = "error";
  } else if (status >= 400) {
    statusClassName = "warn";
  } else {
    statusClassName = "success";
  }
  return <StyledMessageStatusIcon className={`${statusClassName} ${className}`}></StyledMessageStatusIcon>;
};

export default MessageStatusIcon;
